export const removeNonAlphabets = (input: string): string => input.replace(/[^a-zA-Z\s]/g, '');
